module.exports = flarum.core.compat['components/ExtensionsPage'];